var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3456 0.666687C16.1021 0.670937 17.9948 0.689354 20.0065 0.770104L20.7205 0.80127C22.7449 0.896187 24.7679 1.06052 25.7723 1.3396C27.1111 1.71644 28.1622 2.81294 28.5178 4.2041C29.0845 6.4141 29.1553 10.7236 29.1638 11.7677L29.1652 11.983V12.2295C29.1553 13.2736 29.0845 17.5845 28.5178 19.7931C28.158 21.1885 27.1054 22.2864 25.7723 22.6576C24.7679 22.9367 22.7449 23.101 20.7205 23.1959L20.0065 23.2285C17.9948 23.3079 16.1021 23.3277 15.3456 23.3305L15.0127 23.3319H14.6515C13.0506 23.322 6.35548 23.2498 4.22481 22.6576C2.88748 22.2808 1.8349 21.1843 1.47931 19.7931C0.912646 17.5831 0.841813 13.2736 0.833313 12.2295V11.7677C0.841813 10.7236 0.912646 6.41269 1.47931 4.2041C1.83915 2.80869 2.89173 1.71077 4.22623 1.34102C6.35548 0.747437 13.0521 0.675187 14.6529 0.666687H15.3456ZM12.1652 7.04169V16.9584L20.6652 12L12.1652 7.04169Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.94faedfced74c8ea7a31dbed0673a136.svg";
export { ForwardRef as ReactComponent };